module.exports = __webpack_public_path__ + "img/onboarding.03c4d659.svg";